import { z } from 'zod'
import { MAX_QUOTE_PACKAGES, QUOTE_MESSAGE_MAX } from '../constants/quote-request.js'

/** Asking a vendor for a quote for an event: the packages it's about, if any, and a message. */
export const createQuoteRequestInputSchema = z
  .object({
    vendorId: z.string().uuid(),
    offeringIds: z
      .array(z.string().uuid())
      .max(MAX_QUOTE_PACKAGES, `Choose up to ${String(MAX_QUOTE_PACKAGES)} packages`)
      .default([]),
    message: z.string().trim().min(1, 'Say what you’d like to know').max(QUOTE_MESSAGE_MAX, `Keep it under ${String(QUOTE_MESSAGE_MAX)} characters`),
  })
  .strict()

export type CreateQuoteRequestInput = z.infer<typeof createQuoteRequestInputSchema>

/** Who at the company quote requests are emailed to; null for its owners. */
export const setQuoteRecipientInputSchema = z.object({ userId: z.string().uuid().nullable() }).strict()

export type SetQuoteRecipientInput = z.infer<typeof setQuoteRecipientInputSchema>
